<template>
    <div class="gmf-comment-section-modal">
        <CommentSection :targetId="targetId" :showProductInfo="true" />
    </div>
</template>

<style>
.gmf-comment-section-modal {
    max-width: 100%;
    width: 700px;
    min-height: 400px;
}
</style>

<script>
import CommentSection from '@/widgets/CommentSection';

export default {
    components: {
        CommentSection,
    },
    props: [
        'targetId',
    ],
};
</script>